import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";
//
import { PrimeIcons } from "primereact/api";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { useEffect, useState, useCallback } from "react";
import { Route, Routes } from "react-router-dom";
import UserController from "./services/user-controller";
import "./styles/App.css";
import { getToken, subscribe } from "./utils/utility";
import About from "./views/about";
import ContactUs from "./views/contact-us";
import Home from "./views/home";
import Login from "./views/login";
import Register from "./views/register";
import RemoteStoreDetails from "./views/remote-store-details";
import RemoteStoreTypes from "./views/remote-store-types";
import RemoteStores from "./views/remote-stores";

function App() {
    const token = getToken();
    const [profile, setProfile] = useState({});
    const [isProfileShow, setIsProfileShow] = useState(false);
    const [loadingPanel, setLoadingPanel] = useState(null);
    //> getData
    const getData = useCallback(async () => {
        const userController = new UserController();
        const profileResult = await userController.getProfile();
        if (profileResult.value) {
            setProfile(profileResult.value);
        }
    }, []);

    subscribe("refreshProfile", (data) => {
        getData();
    });

    //> useEffect
    useEffect(() => {
        getData();
    }, [getData]);

    const confirmSignOut = function () {
        setIsProfileShow(false);
        confirmDialog({
            message: "آیا مطمئن به خروج هستید؟",
            header: "تایید خروج",
            icon: "pi pi-exclamation-triangle",
            defaultFocus: "accept",
            acceptLabel: "بله",
            rejectLabel: "نه",
            accept,
            reject,
        });
    };

    const accept = function () {
        localStorage.clear();
        window.location = "/";
    };

    const reject = function () { };

    const goToPanel = async function (panel, url) {
        const userController = new UserController();
        try {
            setLoadingPanel(panel);
            await userController.autoLogin(url);
        } catch (error) {
            alert(error.toString());
        }
        setLoadingPanel(null);
    };

    return (
        <article
            className="main"
            onClick={(e) => {
                if (!e.target.getAttribute("data-profile-menu"))
                    setIsProfileShow(false);
            }}
        >
            <ConfirmDialog />
            <header>
                <div className="top-banner">
                    <img src="/images/top-banner.jpg" alt="" />
                </div>

                <div className="menu-bar">
                    <ul className="main-menu">
                        <li>
                            <a href="/#">خانه</a>
                        </li>
                        <li>
                            <a href="/#/about">معرفی</a>
                        </li>
                        <li>
                            <a href="/#/remote-stores">فروشگاه ها</a>
                        </li>
                        <li>
                            <a href="/#/login">عضویت</a>
                        </li>
                        <li>
                            <a href="/#/contact-us">تماس با ما</a>
                        </li>
                    </ul>

                    {token && (
                        <>
                            <div className="profile">
                                <div
                                    onClick={() => setIsProfileShow(true)}
                                    data-profile-menu="true"
                                >
                                    <a className={PrimeIcons.USER} data-profile-menu="true"></a>
                                    <div data-profile-menu="true">
                                        <span data-profile-menu="true">{profile.fullName}</span>
                                        <b data-profile-menu="true">{profile.mobile}</b>
                                    </div>
                                    <i
                                        className={PrimeIcons.ANGLE_DOWN}
                                        data-profile-menu="true"
                                    ></i>
                                </div>

                                <a
                                    className={loadingPanel === "dashboard" ? "panel-link loading" : "panel-link"}
                                    href="/#"
                                    onClick={(e) => { e.preventDefault(); goToPanel("dashboard", "https://offplus.ir/CustomersPanel/"); }}
                                >
                                    <i className={PrimeIcons.TH_LARGE}></i>
                                    <span>میز کار</span>
                                </a>

                                <a
                                    className={loadingPanel === "wallet" ? "panel-link loading" : "panel-link"}
                                    href="/#"
                                    onClick={(e) => { e.preventDefault(); goToPanel("wallet", "https://offplus.ir/CustomersPanel/#Wallet"); }}
                                >
                                    <i className={PrimeIcons.WALLET}></i>
                                    <span>کیف پول</span>
                                </a>

                                <ol
                                    data-profile-menu="true"
                                    className={
                                        isProfileShow === true
                                            ? "profile-menu show"
                                            : "profile-menu"
                                    }
                                >
                                    <li data-profile-menu="true">
                                        <a
                                            href="/#/register"
                                            data-profile-menu="true"
                                            onClick={() => setIsProfileShow(false)}
                                        >
                                            <i
                                                className={PrimeIcons.USER_EDIT}
                                                data-profile-menu="true"
                                            ></i>
                                            <span data-profile-menu="true">ویرایش پروفایل</span>
                                        </a>
                                    </li>

                                    <li data-profile-menu="true">
                                        <a
                                            onClick={(e) => { e.preventDefault(); confirmSignOut(); }}
                                            data-profile-menu="true"
                                            href="/#"
                                        >
                                            <i
                                                className={PrimeIcons.SIGN_OUT}
                                                data-profile-menu="true"
                                            ></i>
                                            <span data-profile-menu="true">خروج</span>
                                        </a>
                                    </li>
                                </ol>
                            </div>
                        </>
                    )}

                    <div className="back">
                        <a href="/#" onClick={(e) => { e.preventDefault(); window.history.back() }}>
                            <i className={PrimeIcons.ANGLE_LEFT}></i>
                        </a>
                    </div>
                </div>
            </header>

            <div className="content">
                <Routes>
                    <Route path="/" Component={Home} exact />
                    <Route path="/home" Component={Home} exact />
                    <Route path="/login" Component={Login} exact />
                    <Route path="/register" Component={Register} exact />
                    <Route path="/about" Component={About} exact />
                    <Route path="/contact-us" Component={ContactUs} exact />
                    <Route path="/remote-stores" Component={RemoteStores} exact />
                    <Route path="/remote-store-details" Component={RemoteStoreDetails} exact />
                    <Route path="/remote-store-types" Component={RemoteStoreTypes} exact />
                </Routes>
            </div>

            <footer>
                <div className="links">
                    <div>
                        <h2>دسترسی سریع</h2>
                        <ul>
                            <li>
                                <a href="/#/remote-stores">جستجوی فروشگاه ها</a>
                            </li>
                            <li>
                                <a href="/#/login">عضویت</a>
                            </li>
                            <li>
                                <a href="/#/contact-us">اطلاعات تماس</a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h2>پیوند ها</h2>
                        <ul>
                            <li>
                                <a href="https://taxi.tehran.ir/" target="_blank" rel="noreferrer">
                                    سازمان تاکسیرانی
                                </a>
                            </li>
                            <li>
                                <a href="https://shahrzaad.city/" target="_blank" rel="noreferrer">
                                    اپلیکیشن شهرزاد
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <a referrerpolicy="origin" target="_blank" rel="noreferrer" href="https://trustseal.enamad.ir/?id=544050&Code=UFrISQtIyVcNTnvigvbvkoa182lygDPt"><img referrerpolicy="origin" src="https://trustseal.enamad.ir/logo.aspx?id=544050&Code=UFrISQtIyVcNTnvigvbvkoa182lygDPt" code="UFrISQtIyVcNTnvigvbvkoa182lygDPt" /></a>
                    </div>
                </div>

                <p>
                    © 2026 کلیه حقوق این سایت متعلق به &nbsp;
                    <a href="https://offplus.ir" target="_blank" rel="noreferrer">
                        آف پلاس
                    </a>
                    می باشد
                </p>
            </footer>
        </article>
    );
}

export default App;
